import React from "react";
import { MessageCircle } from "lucide-react";
import { waLink } from "@/lib/whatsapp";
import { useSite } from "@/context/SiteContext";
import { trackEvent } from "@/lib/analytics";

export default function WhatsAppButton({ message, children, className = "", size = "md", testid, context }) {
  const { whatsappNumber } = useSite();
  const sizes = {
    sm: "h-10 px-4 text-sm",
    md: "h-12 px-6 text-sm",
    lg: "h-14 px-8 text-base",
  };
  const onClick = () => trackEvent("whatsapp_click", { context: context || testid || "generic" });
  return (
    <a
      data-testid={testid || "whatsapp-button"}
      href={waLink(whatsappNumber, message)}
      onClick={onClick}
      target="_blank"
      rel="noopener noreferrer"
      className={`inline-flex items-center justify-center gap-2 rounded-full bg-[#25D366] font-bold text-white transition-transform duration-300 hover:-translate-y-0.5 hover:shadow-[0_8px_30px_rgba(37,211,102,0.35)] ${sizes[size]} ${className}`}
    >
      <MessageCircle className="h-5 w-5" />
      {children || "WhatsApp Us"}
    </a>
  );
}
